/* eslint-disable global-require,import/no-unresolved, react/forbid-prop-types, react/no-array-index-key */
import React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from '../../../styles'
import textStyles from '../../../styles/text'
import { webViewTapped } from '../../../actions/tapEvents'

function ImplantedBattery({ regionalContentLookup, deviceModelType }) {
  const { t } = useTranslation('faq')
  const url = regionalContentLookup('implantedBattery')
  return (
    <View>
      <View style={textStyles.faqH1Container}>
        <Text style={[textStyles.h1, styles.shark_grey]} testID="how-battery-work-header">{t('howBatteryWork')}</Text>
      </View>
      <View>
        <Text style={textStyles.bodyContentText}>{t('implantedBatteryParagraph1')}</Text>
        <Text style={textStyles.bodyContentText}>{t('implantedBatteryParagraph2')}</Text>
        {(deviceModelType !== 'Pacemaker') && (
          <Text style={textStyles.bodyContentText}>
            {t('implantedBatteryParagraph3')}
          </Text>
        )}
        {url.length > 0 && (
        <TouchableOpacity
          onPress={() => {
            webViewTapped(url, 'your-device-site')
          }}
          accessibilityLabel={t('access:yourDeviceWebsiteLink')}
          testID="your-device-website"
        >
          <View style={styles.button}>
            <Text style={[styles.hyperlink, styles.textMargin, styles.linkText]}>
              {t('implantedBatteryLearnMoreLink')}
            </Text>
          </View>
        </TouchableOpacity>
        )}
      </View>
    </View>
  )
}

ImplantedBattery.propTypes = {
  deviceModelType: PropTypes.string,
  regionalContentLookup: PropTypes.func.isRequired,
}

ImplantedBattery.defaultProps = {
  deviceModelType: 'default',
}

export default ImplantedBattery
